import { BAND } from "./sections";
import { immersionMode } from "./perf";

export const COLOURS = {
  love: ["#E7A1B4", "#C9587A", "#F3C6D2"],
  nature: ["#FFFFFF", "#F6E27A", "#C9B8E8"],
  spirit: ["#F4A43A", "#F7C548", "#F2A7B8"],
  thoughts: ["#8FA6E8", "#B7A6E6", "#6E8EDB"],
  fire: ["#F0643C", "#F38B4A", "#E24B37"],
};
export const PETAL = "M10 0 C16 6 17 15 10 24 C3 15 4 6 10 0 Z";

export const stillFlowers = () =>
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches || immersionMode() === "simple";

// A few petals of the chosen arch's flower drift past as the visitor passes through.
export function releasePetals(zone) {
  if (stillFlowers()) return;
  const cols = COLOURS[zone] || [BAND[zone]];
  const box = document.createElement("div");
  box.dataset.testid = "arch-petals";
  box.setAttribute("data-zone", zone);
  box.className = "pointer-events-none fixed inset-0 z-[30] overflow-hidden";
  for (let i = 0; i < 11; i++) {
    const s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    s.setAttribute("viewBox", "0 0 20 24");
    s.setAttribute("data-testid", "arch-petal");
    const size = 14 + Math.random() * 14;
    const dx = (Math.random() - 0.5) * 40;
    Object.assign(s.style, {
      position: "absolute",
      left: `${10 + Math.random() * 80}%`,
      top: "-6%",
      width: `${size}px`,
      height: `${size * 1.2}px`,
      opacity: "0",
      "--dx": `${dx}vw`,
      "--rot": `${(Math.random() - 0.5) * 540}deg`,
      animation: `afae-petal ${2.6 + Math.random() * 1.4}s ease-in ${Math.random() * 0.6}s forwards`,
    });
    s.innerHTML = `<path d="${PETAL}" fill="${cols[i % cols.length]}" fill-opacity="0.85"/><path d="M10 3 C11 10 11 16 10 21" stroke="rgba(255,255,255,0.45)" stroke-width="0.8" fill="none"/>`;
    box.appendChild(s);
  }
  document.body.appendChild(box);
  setTimeout(() => box.remove(), 4800);
}

if (typeof window !== "undefined") {
  window.__afaePetals = releasePetals;
}

window.__afaePetals = releasePetals;
